import { render } from "./TheManagerDetails.vue?vue&type=template&id=317fd53d"
import script from "./TheManagerDetails.vue?vue&type=script&lang=js"
export * from "./TheManagerDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__